import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";

import { TopSlider } from "../home/topSlider";
import { Turkilar } from "../home/turkylar";
import MoftaBakh from "../home/moftaBakh";
import { OnlineBakhish } from "../home/onlinebakhish";
import { Topabakh } from "../home/topabakh";
import { MoviesSlider } from "../home/moviesList";
import PentaBanners from "../home/pentaBanner";
import { NostalgiaSlider } from "../home/nostalgia";
import { MaterialSlider } from "../home/materialSlider";
import { base64EncodeWithoutPadding } from "../../utils/data.utils";
import {
  getAgeRangePublicRoute,
  isAgeRangeAllowed,
} from "../../utils/ageRange.util";
import LazyRow from "../common/LazyRow";
import { sortShowcaseItemsForRow } from "./showcaseOrder.utils";
import NextPlayGuideHelper from "../../utils/nextPlayGuideHelper";

const MAINSlider = "mainSlider";
const TURKYLAR = "infinitySlider";
const MOFTABAKH = "freeMovies";
const ONLINEBAKHISH = "onlineCinema";
const MOVIESlider = "moiveSlider";
const MOVIESliderAlt = "movieSlider";
const TOPABAKH = "sportList";
const PENTABanner = "pentaBanner";
const Material = "materialUSilder";
const MaterialAlt = "materialUSlider";
const Nostalgia = "nostalgia";
const ARTISTSlider = "artistSlider";
const LARGEMOVIE = "largeMovieSlider";

// Private/personalized showcase types
const CONTINUE_WATCH = "continueWatch";
const YOU_MAY_LIKE = "youMayLike";
const RECENTLY_UPDATED = "recentlyUpdated";

export const getShowcaseImageURL = (imageName) =>
  `https://fcdn.manabakh.ir/images/${imageName}`;

export const getShowCase = async (version, versionTitle, device) => {
  try {
    const params = {
      version,
      versionTitle,
      device,
      pageIndex: 10,
      pageNumber: 1,
    };

    const response = await httpService.get(getCMSApiRoute("showcase"), {
      params,
    });

    if (response.status !== 200) {
      console.log("خطا در دریافت اطلاعات", { variant: "error" });
      return [];
    }

    const { data } = response.data;

    const {
      mainSliders,
      freeMovies,
      infinitySliders,
      onlineCinemas,
      movieSliders,
      sportList,
      pentaBanners,
      materialSilders,
      nostalgias,
      artistList,
    } = data?.results?.[0];

    return {
      mainSliders,
      freeMovies,
      infinitySliders,
      onlineCinemas,
      movieSliders,
      sportList,
      pentaBanners,
      materialSilders,
      nostalgias,
      artistList,
    };
  } catch (error) {
    console.log(
      `Error on getShowCase ${version}, ${versionTitle}, ${device}: ${error}`
    );
    console.log("خطا در دریافت اطلاعات", { variant: "error" });
    return [];
  }
};

export const ShowCaseComponentSwitch = ({ item, onRowFocus, parentIndex, contentKind }) => {
  const {
    type,
    kind,
    items,
    title,
    description,
    backgroundImage,
    staticItems,
    _id,
    hasMore,
    actionLink,
    categoryKeys,
    genreKeys,
  } = item;

  const isMusicShowcase = kind === "music" || contentKind === "music";
  const nextPlayGuide = isMusicShowcase
    ? NextPlayGuideHelper.getGuideFromShowcaseRow({
        categoryKeys,
        genreKeys,
        title,
      })
    : null;

  // Helper to wrap row output with LazyRow for deferred rendering
  const wrapLazy = (content) => (
    <LazyRow index={parentIndex}>{content}</LazyRow>
  );

  const ageRange = getAgeRangePublicRoute() || 120;

  // For private showcase types (continueWatch, youMayLike, recentlyUpdated),
  // items are raw content objects, not wrapped in { content: ... }
  const isPrivateShowcase = [
    CONTINUE_WATCH,
    YOU_MAY_LIKE,
    RECENTLY_UPDATED,
  ].includes(type);

  // Filter by age range - handle both formats
  const _items = isPrivateShowcase
    ? items?.filter((x) => isAgeRangeAllowed(x.ageRange, ageRange, true))
    : items?.filter((x) => isAgeRangeAllowed(x.content?.ageRange, ageRange));

  const orderedItems = sortShowcaseItemsForRow(item, _items);
  const orderedStaticItems = sortShowcaseItemsForRow(item, staticItems);

  // Convert private showcase items to expected format for MoviesSlider
  // MoviesSlider expects { content: { ... } } structure
  const normalizedItems = isPrivateShowcase
    ? orderedItems?.map((content) => ({ content, sliderType: "portrait" }))
    : orderedItems;

  if (
    normalizedItems?.length < 1 &&
    staticItems?.length < 1 &&
    type !== MOFTABAKH &&
    type !== ARTISTSlider
  ) {
    return null;
  }

  if (items?.length > 0 || staticItems?.length > 0) {
    switch (type) {
      case MAINSlider:
        return wrapLazy(
          <TopSlider
            movies={orderedItems}
            onFocus={onRowFocus}
            id={_id}
            index={parentIndex}
            nextPlayGuide={nextPlayGuide}
          />
        );
      case TURKYLAR:
        return wrapLazy(
          <Turkilar
            movies={orderedItems}
            onFocus={onRowFocus}
            rowTitle={" ترﮐﮯلَر"}
            id={_id}
            index={parentIndex}
            actionLink={actionLink}
            nextPlayGuide={nextPlayGuide}
          />
        );
      case MOFTABAKH:
        return wrapLazy(<MoftaBakh onFocus={onRowFocus} id={_id} index={parentIndex} />);
      case ONLINEBAKHISH:
        return wrapLazy(
          <OnlineBakhish
            movies={orderedItems}
            onFocus={onRowFocus}
            rowTitle={"آنلاین باخیش"}
            id={_id}
            index={parentIndex}
          />
        );
      case TOPABAKH:
        return wrapLazy(
          <Topabakh
            movies={orderedItems}
            onFocus={onRowFocus}
            rowTitle={"توپاباخ"}
            id={_id}
            index={parentIndex}
          />
        );
      case MOVIESlider:
        if (items.length > 0) {
          return wrapLazy(
            <MoviesSlider
              movies={orderedItems}
              onFocus={onRowFocus}
              rowTitle={title}
              shapeType={kind}
              id={_id}
              index={parentIndex}
              hasMore={hasMore}
              actionLink={actionLink}
              contentKind={contentKind}
              nextPlayGuide={nextPlayGuide}
            />
          );
        }
        break;
      case MOVIESliderAlt:
        if (items.length > 0) {
          return wrapLazy(
            <MoviesSlider
              movies={orderedItems}
              onFocus={onRowFocus}
              rowTitle={title}
              shapeType={kind}
              id={_id}
              index={parentIndex}
              hasMore={hasMore}
              actionLink={actionLink}
              contentKind={contentKind}
              nextPlayGuide={nextPlayGuide}
            />
          );
        }
        break;
      case LARGEMOVIE:
        return wrapLazy(
          <MoviesSlider
            movies={orderedItems}
            onFocus={onRowFocus}
            rowTitle={title}
            shapeType={"sport"}
            id={_id}
            index={parentIndex}
            hasMore={hasMore}
            actionLink={actionLink}
            contentKind={contentKind}
          />
        );
      case ARTISTSlider:
        return wrapLazy(
          <MoviesSlider
            movies={items}
            onFocus={onRowFocus}
            rowTitle={title}
            shapeType={"artist"}
            id={_id}
            index={parentIndex}
            hasMore={false}  // Artists don't have View More on homepage
            actionLink={actionLink}
          />
        );
      case Nostalgia:
        return wrapLazy(
          <NostalgiaSlider
            staticItems={orderedStaticItems}
            onFocus={onRowFocus}
            id={_id}
            index={parentIndex}
          />
        );
      case Material:
        return wrapLazy(
          <MaterialSlider
            staticItems={orderedStaticItems}
            onFocus={onRowFocus}
            id={_id}
            index={parentIndex}
          />
        );
      case MaterialAlt:
        return wrapLazy(
          <MaterialSlider
            staticItems={orderedStaticItems}
            onFocus={onRowFocus}
            id={_id}
            index={parentIndex}
          />
        );
      case PENTABanner:
        return wrapLazy(
          <PentaBanners
            onFocus={onRowFocus}
            bannerItems={orderedItems}
            bannerTitle={title}
            bannerDescription={description}
            bannerBackground={getShowcaseImageURL(backgroundImage)}
            id={_id}
            index={parentIndex}
          />
        );
      // Private/personalized showcase types
      case CONTINUE_WATCH:
        return wrapLazy(
          <MoviesSlider
            movies={normalizedItems}
            onFocus={onRowFocus}
            rowTitle={title}
            shapeType={"movie"}
            id={_id}
            index={parentIndex}
            hasMore={false}
            actionLink={null}
            hasTopTranslate={true}
            isContinueWatch={true}
          />
        );
      case YOU_MAY_LIKE:
        return wrapLazy(
          <MoviesSlider
            movies={normalizedItems}
            onFocus={onRowFocus}
            rowTitle={title}
            shapeType={"movie"}
            id={_id}
            index={parentIndex}
            hasMore={false}
            actionLink={null}
          />
        );
      case RECENTLY_UPDATED:
        return wrapLazy(
          <MoviesSlider
            movies={normalizedItems}
            onFocus={onRowFocus}
            rowTitle={title}
            shapeType={"movie"}
            id={_id}
            index={parentIndex}
            hasMore={false}
            actionLink={null}
            hasTopTranslate={true}
          />
        );
      default:
        return null;
    }
  } else {
    return null;
  }
};

export const parseShowcaseTargetURI = (uri = "", targetKind) => {
  const splitedArr = uri?.replace("artist;", "artists;")?.split(";");

  if (splitedArr?.length < 2 || splitedArr?.length > 3) return;

  const [type, target, version] = splitedArr;

  if (!type || !target) return;

  if (type === "showcase") {
    return `/pages/${base64EncodeWithoutPadding(version)}/${target}`;
  } else {
    return targetKind
      ? `/${type}/${target}?kind=${targetKind}`
      : `/${type}/${target}`;
  }
};
